interface AvatarProps {
  name: string;
  size?: "sm" | "md" | "lg";
  tone?: "primary" | "accent" | "secondary";
}

const sizeMap = {
  sm: "h-8 w-8 text-xs",
  md: "h-10 w-10 text-sm",
  lg: "h-12 w-12 text-base",
};

const toneMap = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function Avatar({ name, size = "md", tone = "primary" }: AvatarProps) {
  return (
    <span
      aria-hidden="true"
      className={`flex shrink-0 items-center justify-center rounded-full font-semibold ${sizeMap[size]} ${toneMap[tone]}`}
    >
      {name.slice(0, 1)}
    </span>
  );
}